/*
 * Close any open header menu when leaving or returning to a page.
 *
 * The mega menu is a <details> element. Two things leave it open over content
 * it should not be covering:
 *
 *   1. bfcache. Pressing Back restores the DOM exactly as it was, including
 *      `open`, so the menu reappears on top of the restored page without the
 *      pointer ever being near it.
 *   2. Navigating from a menu link. The old page can paint for a moment with
 *      the panel still mid-fade, which reads as the menu bleeding through.
 *
 * Neither is reproducible on demand, which is why this closes defensively on
 * both transitions rather than trying to catch one specific path. Closing an
 * already-closed menu costs nothing.
 */
(() => {
  const SELECTOR = 'details.header__menu-disclosure[open]';

  function closeAll() {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      el.open = false;
      /* Prestige's disclosure element tracks its own state; tell it, or the
         next hover can think the panel is still open and skip the animation. */
      const host = el.closest('mega-menu-disclosure, dropdown-menu-disclosure');
      if (host && typeof host.close === 'function') {
        try { host.close(); } catch (e) { /* element not upgraded yet */ }
      }
    });
  }

  /* leaving the page */
  window.addEventListener('pagehide', closeAll);

  /* arriving, including a bfcache restore -- event.persisted marks that case */
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) closeAll();
  });

  /* a menu link was clicked: close before the navigation paints */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('details.header__menu-disclosure a[href]');
    if (link) closeAll();
  }, true);

  /* Escape should dismiss it too, which the stock element does not always do
     once focus has moved into the panel */
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
